
const Pane = function (props) {
    return (
      <div className={"tab-pane fade " + (props.isActive ? "show active" : "")} 
            id={"pane_"+ props.id} 
            role="tabpanel" 
            aria-labelledby={"tab_"+ props.id}>
        <h3>{props.data.MahalSubTitle}</h3>
        <p>{props.data.MahalDescription}</p>
      </div>
    );
  }
export default Pane;
